import React, { Fragment } from "react";
import { shallowEqual, useSelector } from "react-redux";

import ToastComponent from "./components/ToastComponent";


export default function Toast(props) {

    let store = useSelector(connectToStore, shallowEqual);

    function renderToast(){
        let {showToast, error, message} = store; 
        return <ToastComponent location={props.location} show={showToast} message={message} success={!error} />
    }  

    return (
      <Fragment>
        {renderToast()}
        {props.children}
      </Fragment>
    );
}

function connectToStore(store) {
	return {
	  showToast: store.global.showToast,
    error: store.global.error,
    message: store.global.message
	};
}
